import ActivityItemBannerScroll from './ActivityItemBannerScroll'
export default ActivityItemBannerScroll

